import React from 'react'
import PropTypes from 'prop-types'

import Error from '@shared/components/error'
import BiddingList from '@shared/components/auction/biddingList'
import AuctionPlayerSingle from '@shared/components/auction/auctionPlayer/playerSingle'
import { numDifferentiation } from '@shared/utils'

const AuctionPlayers = ({ data }) => {
  return (
    <>
      <AuctionPlayerSingle player={data} />
      {data?.aBid?.length > 0 && (
        <>
          <h6>Bid History</h6>
          <div className="br-md overflow-hidden">
            <BiddingList isOpen bidList={data?.aBid} basePrice={numDifferentiation(data?.nBasePrice)} />
          </div>
        </>
      )}
    </>
  )
}

AuctionPlayers.propTypes = {
  data: PropTypes.object
}

export default Error(AuctionPlayers)
